// extracted by mini-css-extract-plugin
export default {"castButtonArea":"i4PEZ","castConnected":"icJWW","castIdle":"Ksksm"};